export const convertSvgToDataUrl = (icon: string, color?: string): string => (
  `data:image/svg+xml;charset=utf-8,${ encodeURIComponent(
    color ? icon.replace(/<svg([^>]*)>/, `<svg$1 fill="${ color }">`) : icon,
  ) }`
);
